"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SASQLookupComponent = require("../SASQLookupComponent");
var _SASQViewComponent = _interopRequireDefault(require("../SASQViewComponent"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SASQRoute = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    fetchParameters,
    getPathLookup = path => `${path}/:id?`,
    getPathView = path => `${path}/:id`,
    SASQLookupComponent: RouteLookupComponent = _SASQLookupComponent.SASQLookupComponent,
    path,
    SASQViewComponent: RouteViewComponent = _SASQViewComponent.default,
    ...props
  } = _ref;
  // Grab the SASQ_MAP and tweak it
  const {
    SASQ_MAP = {}
  } = fetchParameters;
  const lookupRef = (0, _react.useRef)();
  const viewRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, () => ({
    ...lookupRef.current,
    ...viewRef.current
  }));
  if (!SASQ_MAP.perPage) {
    SASQ_MAP.perPage = 25;
  }
  SASQ_MAP.stats = true;

  // Reinsert the SASQ_MAP
  fetchParameters.SASQ_MAP = SASQ_MAP;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
    path: getPathLookup(path),
    render: routeProps => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteLookupComponent, {
        ref: lookupRef,
        ...routeProps,
        fetchParameters: fetchParameters,
        path: path,
        ...props,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Switch, {
          children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
            path: getPathView(path),
            render: innerProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(RouteViewComponent, {
              ref: viewRef,
              ...innerProps,
              fetchParameters: fetchParameters,
              path: path,
              ViewComponent: props.ViewComponent,
              ...props
            })
          })]
        })
      });
    }
  });
});
SASQRoute.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.func]),
  fetchParameters: _propTypes.default.object,
  getPathLookup: _propTypes.default.func,
  getPathView: _propTypes.default.func,
  path: _propTypes.default.string,
  SASQLookupComponent: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
  SASQViewComponent: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
  ViewComponent: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node])
};
var _default = exports.default = SASQRoute;